import React from 'react'

import FAQ from './FAQItem'
import Hero from './Hero'
import Footer from './Footer'

import './glowEffect.css'
import './LandingPage.css'
import NavBar from './NavBar'
import Pricing from './Pricing'
import useGlobalTheme from '../../hooks/useGlobalTheme'

function LandingPage() {
	const theme = useGlobalTheme()
	const isLight = theme === 'light'
	const chromeWebstoreUrl =
		'https://chromewebstore.google.com/detail/loadlineai/cpcnkckpbpefgkcilhclfdefccflgaif'

	return (
		<div className={`min-h-screen flex flex-col ${isLight ? 'bg-white' : 'bg-[#001b2e]'}`}>
			<NavBar />

			<Hero chromeWebstoreUrl={chromeWebstoreUrl} />
			<Pricing />
			<FAQ />
			<Footer />
		</div>
	)
}

export default LandingPage
